// Copyright 2024 Sorama B.V.

import { GenericMeasurement, Point2D, Point3D } from "datatypes/SoramaWebApi";
import { IMeasurementProcessorResolver } from "services/Measurement/IMeasurementProcessorResolver";
import { ISpectralProcessingService } from "services/SoundProcessing/ISpectralProcessingService";
import { ITimeSignalProvider } from "./ITimeSignalProvider";

export class AudioSignalProvider implements ITimeSignalProvider {
    constructor(private readonly processorResolver: IMeasurementProcessorResolver) {}

    public async getTimeSignal(
        measurement: GenericMeasurement,
        mic: Point3D,
        progressCallback: (progress: number) => void
    ): Promise<Point2D[]> {
        const processor = await this.processorResolver.resolveProcessor<ISpectralProcessingService>(
            ISpectralProcessingService,
            measurement
        );

        const signals = await processor.getTimeSignals(
            measurement,
            {
                requestedMicrophone: mic,
                properties: [
                    {
                        timeRange: { from: 0, to: measurement.duration },
                    },
                ],
            },
            progressCallback
        );

        return Promise.resolve(signals[0].data);
    }
}
